import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/data/categories';

const spreadsheetLinks = [
  { name: 'Taobao Spreadsheet', to: '/taobao-spreadsheet' },
  { name: 'Weidian Spreadsheet', to: '/weidian-spreadsheet' },
  { name: '1688 Spreadsheet', to: '/1688-spreadsheet' },
  { name: 'Yoybuy Spreadsheet', to: '/yoybuy-spreadsheet' },
  { name: 'Kakobuy Spreadsheet', to: '/kakobuy-spreadsheet' },
  { name: 'Superbuy Spreadsheet', to: '/superbuy-spreadsheet' },
  { name: 'Pandabuy Spreadsheet', to: '/pandabuy-spreadsheet' },
  { name: 'Sugargoo Spreadsheet', to: '/sugargoo-spreadsheet' },
  { name: 'Mulebuy Spreadsheet', to: '/mulebuy-spreadsheet' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-accent-500">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50 text-accent-500">
                <i className="ri-table-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                Yoybuy Spreadsheet
              </span>
            </a>
            <p className="text-sm text-background-50/80 leading-relaxed mb-4">
              Ваш надёжный источник таблиц товаров для покупок на Taobao, Weidian и 1688 с доставкой в Россию.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Быстрые ссылки</h4>
            <div className="flex flex-col gap-2">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Yoybuy Sheet</a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Купить сейчас</a>
              <Link to="/yoybuy-spreadsheet-guide" className="text-sm text-background-50/75 hover:text-background-50 transition-colors whitespace-nowrap">Руководство</Link>
              <a href="#categories" className="text-sm text-background-50/75 hover:text-background-50 transition-colors whitespace-nowrap">Категории</a>
              <a href="#faq" className="text-sm text-background-50/75 hover:text-background-50 transition-colors whitespace-nowrap">FAQ</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Спредшиты</h4>
            <div className="flex flex-col gap-2">
              {spreadsheetLinks.map((link, idx) => (
                <Link
                  key={idx}
                  to={link.to}
                  className="text-sm text-background-50/75 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Контакты</h4>
            <div className="flex flex-col gap-2">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/75 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-global-line mr-1"></i> kaspreadsheet.com
              </a>
              <span className="text-sm text-background-50/60">
                <i className="ri-map-pin-line mr-1"></i> Россия
              </span>
              <span className="text-sm text-background-50/60">
                <i className="ri-time-line mr-1"></i> Обновлено: 05.07.2026
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/60">
            © 2026 Yoybuy Spreadsheet. Все права защищены.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/60 flex-wrap justify-center">
            <Link to="/" className="hover:text-background-50 transition-colors">Главная</Link>
            <Link to="/yoybuy-spreadsheet-guide" className="hover:text-background-50 transition-colors">Руководство</Link>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="hover:text-background-50 transition-colors cursor-pointer">Основной сайт</a>
          </div>
        </div>
      </div>
    </footer>
  );
}